module.exports = __webpack_public_path__ + "img/illustrations-success.47c6a55f.svg";